export default {
  id: 239,
  title: 'Target #239 - Waves',
  url: 'https://cssbattle.dev/play/239',
  colors: ['#CEEDFF', '#48BF7D'],
  solution:
    '<p a><p b><p c><p d><style>p[a],p[d]{left:5}body{background:#ceedff}p{position:fixed;margin:0}p[a],p[b],p[c]{top:170;width:250;height:100;border-style:solid;border-width:0 0 30px 30px;border-color:#48bf7d;border-radius:0 0 0 9in}p[b]{left:135}p[c]{left:265}p[d]{top:155;width:30;height:30;background:#48bf7d;border-radius:1in;box-shadow:130px 0 #48bf7d,260px 0 #48bf7d',
}
